import { useSyncExternalStore } from 'react'

// Fields holding typed text not yet passed to their form, such as a time picker's typed time.
const pending = new Set<string>()
const listeners = new Set<() => void>()

/**
 * Says a field holds typed text it has not yet passed to its form, or no longer does, so leaving
 * the page asks first (`useUnsavedChangesPrompt`) though the form has not seen the change.
 */
export function setPendingEdit(key: string, isPending: boolean): void {
  if (pending.has(key) === isPending) {
    return
  }
  if (isPending) {
    pending.add(key)
  } else {
    pending.delete(key)
  }
  for (const listener of listeners) {
    listener()
  }
}

/** Some field on the page holds typed text not yet passed to its form. */
export function hasPendingEdits(): boolean {
  return pending.size > 0
}

function subscribe(listener: () => void): () => void {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

/** `hasPendingEdits`, rendering again as it changes. */
export function usePendingEdits(): boolean {
  return useSyncExternalStore(subscribe, hasPendingEdits, () => false)
}
